module.exports = __webpack_public_path__ + "static/media/directorio-hombre-laptop.eb023bf3.png";